import React from 'react';
import styles from './css/Modal.module.css';

const Modal = ({ message, onClose }) => {
    return (
        <div className={styles.modalBackdrop}>
            <div className={styles.modalContent}>
                <p>{message}</p>
                <button onClick={onClose} className={styles.okButton}>OK</button>
            </div>
        </div>
    );
};

export default Modal;
